const { VEHICLE_TYPE_ENUM } = require('../enum/vehicle-type');

const isVehicleCar = (vehicle) => {
    if(!vehicle) {
        return false;
    }

    return vehicle.vehicleType === VEHICLE_TYPE_ENUM.CAR;
};

const isVehicleElectricOrHybrid = (vehicle) => {
    if (!vehicle) {
        return false;
    }

    const containsElectric = (str) => {
        str = str.toLowerCase();

        return str.includes("electric") || str.includes("hyb");
    };

    // Currently all Tesla vehicles have fuel/fuelType set to "Unknown"
    if (vehicle.make && vehicle.make.trim().toLowerCase() === "tesla") {
        return true;
    }

    if (vehicle.fuel && vehicle.fuel.trim() !== "") {
        return containsElectric(vehicle.fuel);
    }

    if (vehicle.fuelType && vehicle.fuelType.trim() !== "") {
        return containsElectric(vehicle.fuelType);
    }

    return false;
};

const isVehicleElectricOrHybridCar = (vehicle) => {
    if (!vehicle) {
        return false;
    }

    return isVehicleCar(vehicle) && isVehicleElectricOrHybrid(vehicle);
};

module.exports = {
    isVehicleElectricOrHybridCar
};